import { render, staticRenderFns } from "./sidebar-external-message.vue?vue&type=template&id=5a683a6c&"
import script from "./sidebar-external-message.vue?vue&type=script&lang=js&"
export * from "./sidebar-external-message.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-external-message.vue?vue&type=style&index=0&id=5a683a6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports